
$(function () {
    $('.btnNextStep2, .btnPreviousStep2').click(function () {
        $('a[href="#step2"]').tab('show');
    });

    $('.btnNextStep3').click(function () {
        $('a[href="#step3"]').tab('show');
    });

    $('.btnPreviousStep1').click(function () {
        $('a[href="#step1"]').tab('show');
    });
});

